// SystemMenu.js
// Component for System Menu

// Imports
import React from 'react';
import { Menu, MenuItem, MenuDivider } from '@blueprintjs/core';
import LocalStorage from '../../config/LocalStorage';
import PropTypes from 'prop-types';

// Component Class
// Shows a menu with system options
class SystemMenu extends React.Component {
  // Saves the current state to a file
  saveState = () => {
    LocalStorage.DownloadState();
  };

  // Loads the state from a file
  loadState = () => {
    document.getElementById('file_loadstate').click();
  };

  // Reopens last closed order
  reopenOrder = () => {
    this.props.reopenOrder();
  };

  // Closes open order, if it is not empty
  closeOrder = () => {
    this.props.closeOrder(this.props.products);
  };

  // Resets all application data
  resetAll = () => {
    LocalStorage.ResetState();
  };

  // Renders Component
  render() {
    return (
      <div>
        <Menu >
          <MenuItem icon="cloud-download" text="Salvar" onClick={this.saveState} />
          <MenuItem icon="cloud-upload" text="Carregar" onClick={this.loadState} />
          <MenuDivider />
          <MenuItem
            icon="add"
            text="Reabrir Último Pedido"
            disabled={this.props.prevOrders.length === 0}
            onClick={this.reopenOrder}
          />
          <MenuItem icon="remove" text="Fechar Pedido" onClick={this.closeOrder} />
          <MenuDivider />
          <MenuItem intent="danger" icon="trash" text="Apagar Tudo" onClick={this.resetAll} />
        </Menu>
      </div>
    );
  }
}

// Required Properties
SystemMenu.propTypes = {
  products: PropTypes.object.isRequired,
  prevOrders: PropTypes.array.isRequired,
  closeOrder: PropTypes.func.isRequired,
  reopenOrder: PropTypes.func.isRequired,
}

// Exports
export default SystemMenu;



// WEBPACK FOOTER //
// ./src/components/Navbar/SystemMenu.js